import { Component, Input } from '@angular/core';
import { TIPPY_PROPS } from '../../constants/tippy-props.constant';

@Component({
  selector: 'app-input-label',
  templateUrl: './input-label.component.html',
  styleUrls: ['./input-label.component.scss']
})
export class InputLabelComponent {
  @Input() inputId: string;
  @Input() inputName: string;
  @Input() mandatory: boolean;
  @Input() isClickable: boolean;
  @Input() helpTooltipText: string;
  public tippyProps = TIPPY_PROPS;
}
